import React from "react";
import { motion } from "framer-motion";
import { SectionLabel } from "./SectionLabel";
import { EditorialImage } from "./EditorialImage";
import { Photo } from "../data/photography";
import { ledgerEase } from "../utils/motion";
type PageIntroProps = {
  label: string;
  title: string;
  statement?: string;
  image?: Photo;
  imageCaption?: string;
  children?: React.ReactNode;
};
export function PageIntro({
  label,
  title,
  statement,
  image,
  imageCaption,
  children
}: PageIntroProps) {
  if (image) {
    return <section className="shell pb-20 pt-14 md:pb-28 md:pt-20" data-id="element-428" data-mp="3vvd6aum16e1n">
        <div className="grid grid-cols-12 items-end gap-x-6 gap-y-12" data-id="element-429" data-mp="3hx5bas8k1mt4">
          <div className="col-span-12 lg:col-span-7 lg:pb-10 lg:pr-6" data-id="element-430" data-mp="3hz81pddmdhyd">
            <SectionLabel data-id="element-431" data-mp="3mueye18h1mds">{label}</SectionLabel>
            <motion.h1 initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: ledgerEase
          }} className="mt-8 font-display text-[clamp(2.75rem,5.4vw,5.25rem)] leading-[1.02] tracking-[-0.015em] text-navy" data-id="element-432" data-mp="26hzy2uass5v9">
              {title}
            </motion.h1>
            {statement && <p className="mt-8 max-w-xl font-display text-2xl italic leading-snug text-oxblood" data-id="element-433" data-mp="1it228njlyw2y">{statement}</p>}
            {children}
          </div>
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.3,
          ease: ledgerEase
        }} className="col-span-12 lg:col-span-5" data-id="element-434" data-mp="1dsnr2wmpn60p">
            <EditorialImage image={image} caption={imageCaption} priority data-id="element-435" data-mp="1mssyv7vtg6fe" />
          </motion.div>
        </div>
      </section>;
  }
  return <section className="shell pb-16 pt-20 md:pb-24 md:pt-28 lg:pt-32" data-id="element-436" data-mp="1wk6vn7wdus4u">
      <div className="grid grid-cols-12 gap-x-6 gap-y-8" data-id="element-437" data-mp="2ajydjjq0sso4">
        <div className="col-span-12 lg:col-span-3 lg:pt-5" data-id="element-438" data-mp="2akhlq8pvc2oy">
          <SectionLabel data-id="element-439" data-mp="26jfkxngazikv">{label}</SectionLabel>
        </div>
        <div className="col-span-12 lg:col-span-9" data-id="element-440" data-mp="26gte5q18l73p">
          <motion.h1 initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: ledgerEase
        }} className="font-display text-[clamp(2.75rem,6.4vw,6rem)] leading-[1.02] tracking-[-0.015em] text-navy" data-id="element-441" data-mp="2dmvwu9rpuo3o">
            {title}
          </motion.h1>
          {statement && <p className="mt-10 max-w-2xl font-display text-2xl italic leading-snug text-oxblood md:text-[1.9rem]" data-id="element-442" data-mp="2wckjlfleyy7y">
              {statement}
            </p>}
          {children}
        </div>
      </div>
    </section>;
}